export enum ApiPaths {
    lookup = "/lookup/",
    accounts = "/accounts/",
    clients = "/clients/",
    buildings = "/buildings/",
    submissions = "/submissions/",
    submissionscontremaitre = "/submissions-contremaitre/",
    contracts = "/contracts/",
    proposition = "/propositions/",
    contractors = "/contractors/",
    templates = "/templates/",
    invoices = "/invoices/",
    orders = "/orders/",
    notes = "/notes/"
}